(function () {
  // Hover para thelab-nav-desktop: abre/cierra .thelab-mega via is-open al pasar el mouse.
  // El panel ya tiene opacity:0/1 con transition en base.css, solo hay que togglear la clase.
  function bindMegaMenuHover() {
    const header = document.querySelector('.header-wrapper[data-mega-menu-hover]');
    if (!header || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    header.querySelectorAll('[data-mega]').forEach(function (mega) {
      if (mega.dataset.hoverBound) return;
      mega.dataset.hoverBound = 'true';

      const trigger = mega.querySelector('[data-mega-trigger]');
      let timer;

      mega.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        document.querySelectorAll('[data-mega].is-open').forEach(function (other) {
          if (other !== mega) {
            other.classList.remove('is-open');
            const t = other.querySelector('[data-mega-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
        mega.classList.add('is-open');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
      });

      mega.addEventListener('mouseleave', function () {
        timer = setTimeout(function () {
          mega.classList.remove('is-open');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }, 200);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bindMegaMenuHover);
  document.addEventListener('shopify:section:load', bindMegaMenuHover);
})();

document.addEventListener('DOMContentLoaded', () => {
  const outerDetails = document.querySelector('.mobile-facets__disclosure');
  if (!outerDetails) return;

  function getActiveFilterIds() {
    return [...outerDetails.querySelectorAll('.mobile-facets__details')]
      .filter((d) =>
        d.querySelector('input[type="checkbox"]:checked') ||
        [...d.querySelectorAll('input[type="number"]')].some((i) => i.value !== '')
      )
      .map((d) => d.id);
  }

  function getSavedIds() {
    try {
      const state = JSON.parse(sessionStorage.getItem('mf_state') || '{}');
      return state.params === window.location.search ? (state.ids || []) : [];
    } catch {
      return [];
    }
  }

  function saveIds(ids) {
    sessionStorage.setItem('mf_state', JSON.stringify({ params: window.location.search, ids }));
  }

  new MutationObserver(() => {
    if (!outerDetails.classList.contains('menu-opening')) return;
    const toOpen = [...new Set([...getActiveFilterIds(), ...getSavedIds()])];
    toOpen.forEach((id) => {
      const d = document.getElementById(id);
      if (d) d.setAttribute('open', '');
    });
  }).observe(outerDetails, { attributes: true, attributeFilter: ['class'] });

  new MutationObserver((mutations) => {
    if (mutations.some((m) => m.attributeName === 'open')) {
      const openIds = [...outerDetails.querySelectorAll('.mobile-facets__details[open]')].map((d) => d.id);
      saveIds(openIds);
    }
  }).observe(outerDetails, { attributes: true, attributeFilter: ['open'], subtree: true });
});

(function () {
  var headerEl = document.querySelector('header[data-thelab-flow]');
  if (!headerEl) return;

  if (headerEl.dataset.thelabFlow) return;
  if (window.location.pathname === '/') return;

  var lastFlow = localStorage.getItem('thelab_last_flow');
  if (!lastFlow) return;

  headerEl.querySelectorAll('[data-thelab-nav-flow="' + lastFlow + '"]').forEach(function (wrapper) {
    while (wrapper.firstChild) {
      wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
    }
    wrapper.remove();
  });
  headerEl.querySelectorAll('[data-thelab-nav-flow]').forEach(function (el) { el.remove(); });
})();

(function () {
  var SIZE_ORDER = [
    'TAMAÑO ÚNICO', 'TALLA ÚNICA', 'ÚNICO', 'ÚNICA', 'ONE SIZE', 'OS',
    'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '3XL', '4XL', '5XL',
    'XS/S', 'S/M', 'M/L', 'L/XL'
  ];

  function sizeRank(label) {
    var n = (label || '').trim().toUpperCase();
    var idx = SIZE_ORDER.indexOf(n);
    if (idx !== -1) return idx;
    var num = parseFloat(n);
    if (!isNaN(num)) return 1000 + num;
    return 9999;
  }

  window.__thelabSizeRank = sizeRank;

  function sortCardTrack(track) {
    var btns = Array.prototype.slice.call(track.querySelectorAll('.card__variant-opt'));
    if (btns.length < 2) return;
    btns.sort(function (a, b) {
      var la = a.querySelector('.card__qa-text');
      var lb = b.querySelector('.card__qa-text');
      return sizeRank(la ? la.textContent : a.textContent) - sizeRank(lb ? lb.textContent : b.textContent);
    });
    btns.forEach(function (btn) { track.appendChild(btn); });
  }

  window.__thelabSortCardTrack = sortCardTrack;

  function sortPdpPills(pills) {
    var btns = Array.prototype.slice.call(pills.querySelectorAll('.thelab-pdp__pill--size'));
    if (btns.length < 2) return;
    var sorted = btns.slice().sort(function (a, b) { return sizeRank(a.textContent) - sizeRank(b.textContent); });
    if (sorted.every(function (btn, i) { return btn === btns[i]; })) return;
    sorted.forEach(function (btn) { pills.appendChild(btn); });
  }

  function sortAll() {
    document.querySelectorAll('.card__variant-track').forEach(sortCardTrack);
    document.querySelectorAll('.thelab-pdp__pills').forEach(sortPdpPills);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sortAll);
  } else {
    sortAll();
  }

  var sortTimer;
  new MutationObserver(function (mutations) {
    var needsSort = false;
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (
          node.classList.contains('card__variant-track') ||
          node.classList.contains('thelab-pdp__pill--size') ||
          (node.querySelector && (node.querySelector('.card__variant-track') || node.querySelector('.thelab-pdp__pill--size')))
        ) needsSort = true;
      });
    });
    if (needsSort) { clearTimeout(sortTimer); sortTimer = setTimeout(sortAll, 30); }
  }).observe(document.body, { childList: true, subtree: true });
})();
